import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LANGUAGE_OPTIONS = [
  { value: 'pt' as const, compactLabel: 'PT', fullLabel: 'Português' },
  { value: 'en' as const, compactLabel: 'EN', fullLabel: 'English' },
  { value: 'es' as const, compactLabel: 'ES', fullLabel: 'Español' },
];

const LanguageSelector: React.FC<{ className?: string; variant?: 'compact' | 'full' }> = ({
  className = '',
  variant = 'compact',
}) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border border-slate-700 bg-slate-900/70 p-1 shadow-[0_10px_28px_rgba(0,0,0,0.2)] backdrop-blur-xl ${className}`}
      role="tablist"
      aria-label={t('languageSelectorLabel')}
    >
      {LANGUAGE_OPTIONS.map((option) => {
        const active = option.value === language;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => setLanguage(option.value)}
            className={`min-w-10 rounded-full px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.22em] transition-all ${
              active
                ? 'bg-cyan-500 text-slate-950 shadow-[0_0_18px_rgba(34,211,238,0.18)]'
                : 'text-slate-400 hover:bg-white/[0.04] hover:text-white'
            }`}
            aria-pressed={active}
          >
            {variant === 'full' ? option.fullLabel : option.compactLabel}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSelector;
